import axiosTokenInstance from 'services/api/backoffice';
import { GET_CHANNEL, GET_CHANNEL_ERROR } from '_models/redux/types';

// Action function
export const getChannelAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/callcenter/channels?status=all`);

    const { data, status } = response || {};

    dispatch({
      method: 'get',
      payload: data || {},
      status: status || {},
      type: GET_CHANNEL,
    });
  } catch (e) {
    dispatch({
      method: 'get',
      payload: e || {},
      type: GET_CHANNEL_ERROR,
    });
  }
};
